import React, { useEffect, useState } from "react";
import "./Substitution.css";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";

import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { API_URL, backend } from "../../../config";

const Substitution = (props) => {
  const { data } = props;

  const [openSubstitutionDialog, setOpenSubstitutionDialog] = useState(false);
  const [substitutedItem, setSubstitutedItem] = useState(null);

  const handleCloseSubstitutionDialog = () => setOpenSubstitutionDialog(false);

  const handleClickSubstitutionDialog = () => setOpenSubstitutionDialog(true);

  useEffect(() => {
    const getSubstitutedItem = async () => {
      await backend
        .get(`${API_URL}products?upc=${data.original_product}&no_page=1`)
        .then((response) => {
          const substituteObj = response.data.find(
            (item) => item.upc === data.original_product,
          );

          setSubstitutedItem(substituteObj);
        });
    };

    if (
      data.hasOwnProperty("original_product") &&
      data.original_product !== data.product
    ) {
      getSubstitutedItem();
    }
  }, [data]);

  return (
    <>
      {substitutedItem !== null ? (
        <>
          <Tooltip title="Substitution Information">
            <IconButton
              aria-label="substitution_information"
              onClick={handleClickSubstitutionDialog}
            >
              <ChangeCircleIcon />
            </IconButton>
          </Tooltip>
          <Dialog
            onClose={handleCloseSubstitutionDialog}
            open={openSubstitutionDialog}
          >
            <DialogContent>
              <Grid container marginBottom="20px">
                <Grid
                  item
                  xs={12}
                  marginTop="20px"
                  marginBottom="20px"
                  textAlign="center"
                >
                  <img
                    src={substitutedItem && substitutedItem.url}
                    alt="product"
                    height="150px"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography align="center">
                    {substitutedItem && substitutedItem.item_code
                      ? substitutedItem.item_code.item_code
                      : ""}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography align="center">
                    {substitutedItem && substitutedItem.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} marginTop="20px">
                  <Typography variant="h6" align="center">
                    {`$${
                      substitutedItem && substitutedItem.display_unit_price
                    } Unit`}
                  </Typography>
                </Grid>
                <Grid item xs={12} marginBottom="20px">
                  <Typography variant="h6" align="center">
                    {`$${
                      substitutedItem && substitutedItem.display_case_price
                    } Case (${
                      substitutedItem && substitutedItem.units_per_case
                    })`}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography align="right">Item Description:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography align="left" className="typographySpacing">
                    {substitutedItem && substitutedItem.api_description
                      ? substitutedItem.api_description
                      : ""}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography align="right">UPC:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography align="left" className="typographySpacing">
                    {substitutedItem && substitutedItem.upc
                      ? substitutedItem.upc
                      : ""}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

/* Substitution.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
}; */

export default Substitution;
